<svelte:options runes={true} />

<script lang="ts">
  interface Props {
    label: string;
    as?: "button" | "a";
    href?: string;
    onclick?: () => void;
    /** Set by a shell rendering this row inside a listbox — see SearchAutosuggestCore.items. */
    optionId?: string;
    selected?: boolean;
    class?: string;
  }

  let { label, as, href, onclick, optionId, selected, class: className = "" }: Props = $props();

  const asLink = $derived(as === "a" || (as === undefined && Boolean(href)));
</script>

{#if asLink}
  <a
    {href}
    {onclick}
    role={optionId ? "option" : undefined}
    id={optionId}
    aria-selected={optionId ? selected : undefined}
    tabindex={optionId ? -1 : undefined}
    class={["da-nav-menu-item", className]}
  >
    {label}
  </a>
{:else}
  <button
    type="button"
    {onclick}
    role={optionId ? "option" : undefined}
    id={optionId}
    aria-selected={optionId ? selected : undefined}
    tabindex={optionId ? -1 : undefined}
    class={["da-nav-menu-item", className]}
  >
    {label}
  </button>
{/if}

<style>
  @layer aurora {
    .da-nav-menu-item {
      display: flex;
      align-items: center;
      width: 100%;
      /* Figma 9978:1566 — 6px vertical, 12px horizontal. The 6px is off the
         --da-space scale (4 then 8); the design is the source of truth here. */
      padding: 6px var(--da-space-3);
      background: none;
      border: none;
      text-align: left;
      cursor: pointer;
      color: var(--da-color-charcoal-500);
      font-family: var(--da-font-family-primary);
      font-size: var(--da-font-size-md);
      font-weight: 500;
      /* 24px per the design; the nearest token is --da-line-height-md at 22px. */
      line-height: 24px;
      text-decoration: none;
      /* Softens the highlight as the arrow keys walk the list, as the abandoned
         branch did. Background only — transitioning `all` here would also animate
         the radius below, which should switch instantly. */
      transition: background var(--da-duration-fast);
    }

    @media (prefers-reduced-motion: reduce) {
      .da-nav-menu-item {
        transition: none;
      }
    }

    /* sand-800, not sand-500: the desktop autosuggest panel is itself sand-500,
       so a sand-500 highlight rendered but was invisible. */
    .da-nav-menu-item[aria-selected="true"] {
      background: var(--da-color-brand-sand-800);
      border-radius: var(--da-radius-sm);
    }
  }
</style>
